import { render, staticRenderFns } from "./LiquidationDetails.vue?vue&type=template&id=a67020e4&"
import script from "./LiquidationDetails.vue?vue&type=script&lang=js&"
export * from "./LiquidationDetails.vue?vue&type=script&lang=js&"
import style0 from "./LiquidationDetails.vue?vue&type=style&index=0&id=a67020e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports